import { useState } from "react";
import { PostFinanceAccountsResponseModel } from "@/features/accounts/finance/services/post-accounts-model";


export const usePostFinanceAccountStates = () => {
  const [financeAccountId, setFinanceAccountId] = useState("");
  const [finances, setFinances] = useState<PostFinanceAccountsResponseModel[]>([]);

  // エラーダイアログ表示フラグ情報
  const [isShowErrorDialog, setIsShowErrorDialog] = useState({
    isError: false,
    errorMessage: "",
    errorCode: "",
  });

  return {
    financeAccountId,
    setFinanceAccountId,
    finances,
    setFinances,
    isShowErrorDialog,
    setIsShowErrorDialog,
  };
};
